<template>
  <div class="container lms-wrapper-two">
    
    <student-nav />

    <div class="lms-content" @click="closeLevel2()">
      <student-header :navbarmode.sync="navbarMode" ref="lmsv4header" class="filled" />
     
      <div class="lms-content-body" style="height: calc(100vh - 80px)">
        
      
      <vue-custom-scrollbar class="" style="height: calc(100vh - 80px);">
        <div class="container-fluid mg-y-30">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb breadcrumb-style4 mg-b-10">
              <li class="breadcrumb-item"><router-link :to="{ name: 'buddyParticipant' }" class="tx-11" style="color: #444">Шинэ ажилтан</router-link></li>
              <li class="breadcrumb-item active tx-14" aria-current="page">FAQ</li>
            </ol>
          </nav>


          <div class="row" data-masonry='{"percentPosition": true }' >
            <div v-for="(faq,i) in faqs" class="col-sm-12 col-lg-6">
              <div class="bg-white rounded-20 mg-b-10">
                <div @click="openFaq(faq)" role="button" :class="`pd-x-30 pd-y-15 ${faq.id==curInd?'bd-b':''} tx-medium d-flex align-items-center`">
                  {{ faq.task }}
                  <div class="bg-light mg-l-auto rounded-10 pd-x-8 pd-y-5">
                    <feather :type="faq.id==curInd?'minus':'plus'"></feather>
                  </div>
                </div>
                <div v-if="faq.id==curInd" class="pd-x-30 pd-y-20" style="color: #7A7B7D" v-html="faq.taskDesc"></div>
              </div>
            </div>
          </div>
        </div>
      </vue-custom-scrollbar>
    </div>

    </div>




    
  </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";



import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";

import { localSave, localRead } from "@/libs/util";

const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import { Notification } from "element-ui";

import Masonry from "masonry-layout"

export default {
  components: {
    vueCustomScrollbar,
    
    userCover: () => ({
      component: import("@/views/modules/lms/components/userCover.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentCalendar: () => ({
      component: import("@/views/modules/lms/teacher/components/calendar.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    partUserSidebar: () => ({
      component: import( "@/views/modules/lms/student/parts/userSidebar.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      myResBaseUrl: "https://res.gosmart.mn/",
      faqs:[],
      curInd: 0,
      navbarMode: 0,
      mustJoinCourses: {
        all: 0,
        finished: 0,
      }
    };
  },
  // beforeCreate() {
  //   require('@/assets/scss/pages/learning.scss');
  // },
  created() {
    this.fetchResBase();
  },
  mounted() {
    this.init();
    // console.log('mntd');
  },
  destroyed() {
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    init(){
      // console.log('init fiored');
      let _pid = 0;
      let proj = this.$store.state.app.groupDefaultProjects.filter(
        (x) => x.objectTypeId == 610
      );
      // console.log('prj', proj)
      if (proj.length) {
        _pid = proj[0].id;
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "TaskCore/GetCoreList" },
          data: {
            projectId: _pid,
            skip: 0,
            size: 2000,
            id: 0,
            model: {
              isPublic: true
            },
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if(res!=false){
            console.log('res.data.tasks.length', res.data.tasks.length);
            if (res.data.tasks.length > 0){
              this.faqs= res.data.tasks;
              this.openFaq(this.faqs[0]);
            }
          }
        });
      }
    },
    openFaq(faq){
      if(this.curInd== faq.id){
        this.curInd= faq.id;  
      }else{
        this.curInd= faq.id;  
      }
      
      this.$nextTick(()=>{
        var row = document.querySelector("[data-masonry]");
        new Masonry(row, {
          // options
          percentPosition: true,
        });
      });
      
    },
    logout(){
      this.$refs.lmsv4header.logout();
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    ...mapActions(["handleAside", "resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    
  },
};
</script>